import { Component, OnInit } from '@angular/core';

import { ToasterService, ToasterConfig, Toast, BodyOutputType } from 'angular2-toaster';
import 'style-loader!angular2-toaster/toaster.css';
import { AnalyticsService } from './services/analytics.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'app';
  subscription;
  id;
  config: ToasterConfig;

  constructor(private toasterService: ToasterService, private analyticsService: AnalyticsService) {
    // console.log('!!!!!!!!!!!!!!!!!');
  }

  ngOnInit() {
    this.config = new ToasterConfig({
      positionClass: 'toast-top-right',
      timeout: 5000,
      newestOnTop: true,
      tapToDismiss: true,
      preventDuplicates: false,
      showCloseButton: true,
      animation: 'fade',
      limit: 5
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts